/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'fabric.editor.headingLink.ascSortingLabel': 'vzestupně',
  'fabric.editor.headingLink.copied': 'Zkopírováno!',
  'fabric.editor.headingLink.copyAnchorLink': 'Kopírovat odkaz na nadpis',
  'fabric.editor.headingLink.copyAriaLabel': 'Kopírovat',
  'fabric.editor.headingLink.descSortingLabel': 'sestupně',
  'fabric.editor.headingLink.failedToCopy': 'Kopírování se nezdařilo',
  'fabric.editor.headingLink.noneSortingLabel': 'Žádné',
  'fabric.editor.inlineComment.marker.end': 'konec vloženého komentáře',
  'fabric.editor.inlineComment.marker.start': 'začátek vloženého komentáře',
};
